import { env } from '../env';
import { ServiceCreateCommand, ServiceItem, ServiceUpdateCommand } from '../types/service';

const BASE_URL = env.apiUrl;

function authHeaders(accessToken: string): HeadersInit {
  return { Authorization: `Bearer ${accessToken}`, 'Content-Type': 'application/json' };
}

export async function listServicesAdmin(accessToken: string): Promise<ServiceItem[]> {
  const res = await fetch(`${BASE_URL}/api/v1/services/admin`, { headers: authHeaders(accessToken) });
  if (!res.ok) throw new Error('Failed to load services');
  return res.json();
}

export async function getService(accessToken: string, serviceGuid: string): Promise<ServiceItem> {
  const res = await fetch(`${BASE_URL}/api/v1/services/${serviceGuid}`, { headers: authHeaders(accessToken) });
  if (!res.ok) throw new Error('Failed to load service');
  return res.json();
}

export async function createService(accessToken: string, cmd: ServiceCreateCommand): Promise<ServiceItem> {
  const res = await fetch(`${BASE_URL}/api/v1/services`, {
    method: 'POST',
    headers: authHeaders(accessToken),
    body: JSON.stringify(cmd),
  });
  if (!res.ok) throw new Error('Failed to create service');
  return res.json();
}

export async function updateService(
  accessToken: string,
  serviceGuid: string,
  cmd: ServiceUpdateCommand
): Promise<ServiceItem> {
  const res = await fetch(`${BASE_URL}/api/v1/services/${serviceGuid}`, {
    method: 'PUT',
    headers: authHeaders(accessToken),
    body: JSON.stringify(cmd),
  });
  if (!res.ok) throw new Error('Failed to update service');
  return res.json();
}

export async function deleteService(accessToken: string, serviceGuid: string): Promise<void> {
  const res = await fetch(`${BASE_URL}/api/v1/services/${serviceGuid}`, {
    method: 'DELETE',
    headers: authHeaders(accessToken),
  });
  if (!res.ok) throw new Error('Failed to delete service');
}
